import { getCartIDAndAuth } from '@src/quince-site-common/src/hooks/cart/hooks/new-cart-helper'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export function getExpressCheckoutSrc(showBothButtons: boolean, isMobile?: boolean) {
  const { cartID, authCode } = getCartIDAndAuth()

  if (!cartID || !authCode || !isBrowser()) {
    return {
      src: '',
    }
  }

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return {
      src: `http://localhost:4200/express-checkout-buttons?cart_id=${cartID}&cart_auth_Code=${authCode}&show_both=${showBothButtons}&show_large_buttons=${isMobile}`,
    }
  }

  const origin = window.location.origin

  const url = new URL(origin)
  // @i18n-ignore
  url.pathname = `checkout/express-checkout-buttons`
  url.searchParams.append('cart_id', cartID)
  url.searchParams.append('cart_auth_Code', authCode)
  url.searchParams.append('show_both', `${showBothButtons}`)
  url.searchParams.append('show_large_buttons', `${isMobile}`)
  return { src: url.href }
}
